export default "__VITE_ASSET__CYU7Txwo__"